import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import JobState, {IJob, JobList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<JobState, State> = {
  async getJobList(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'job', options, (res: JobList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getJobById(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options._id
    delete options._id
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', `job/${id}`, options, (res: IJob) => {
        commit(mutationType.GET_BY_ID, res)
      })
  },
  async postJob(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .postByLevel(process.env.VUE_APP_API_URL + '/v1', 'job', options, (res: object) => {
        commit(mutationType.CREATE, res)
      })
  },
  async putJob(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options._id
    delete options._id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `job/${id}`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
  async putJobPayment(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options._id
    delete options._id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `job/${id}/slip`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
  async deleteJob(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options._id
    delete options._id
    await HttpRequestServiceWithToken
      .deleteByLevel(
        process.env.VUE_APP_API_URL + '/v1', `job/${id}`, options, (res: object) => {
        commit(mutationType.DELETE, res)
      })
  },
  async getJobTypeList(
    { commit, dispatch, state }: ActionContext<JobState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'job-type', options, (res: JobList) => {
        commit(mutationType.JOB_TYPE, res)
      })
  },
}

export default actions
